(() => {
  const ACTIVE_CLASS = 'is-active';

  const updateCardImage = (productItem, swatch) => {
    const imageSrc = swatch.getAttribute('data-image-src');
    const imageSrcset = swatch.getAttribute('data-image-srcset');
    const imageAlt = swatch.getAttribute('data-image-alt');
    const mediaId = swatch.getAttribute('data-media-id');
    const variantUrl = swatch.getAttribute('data-variant-url');

    if (!imageSrc && !mediaId) return;

    const imageContainer = productItem.querySelector('[data-js-product-item-image]');
    if (!imageContainer) return;

    const slider = imageContainer.querySelector('css-slider');
    if (slider && mediaId) {
      const slide = slider.querySelector(`.product-item__image-${mediaId}`);
      if (slide && typeof slider.changeSlide === 'function' && slide.dataset.index != null) {
        slider.changeSlide(slide.dataset.index);
      }
    } else {
      const img = imageContainer.querySelector('img');
      if (img && imageSrc) {
        img.src = imageSrc;
        if (imageSrcset) img.srcset = imageSrcset;
        if (imageAlt) img.alt = imageAlt;
        img.parentElement?.classList.add('lazyloaded');
      }
    }

    if (variantUrl) {
      productItem.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        if (link.closest('[data-js-product-card-swatches]')) return;
        link.href = variantUrl;
      });
    }
  };

  const onSwatchClick = (event) => {
    const swatch = event.target.closest('[data-js-product-card-swatch]');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const productItem = swatch.closest('[data-js-product-item]');
    const swatches = swatch.closest('[data-js-product-card-swatches]');
    if (!productItem || !swatches) return;

    swatches.querySelectorAll('[data-js-product-card-swatch]').forEach((button) => {
      button.classList.toggle(ACTIVE_CLASS, button === swatch);
    });

    updateCardImage(productItem, swatch);
  };

  document.addEventListener('click', onSwatchClick);
})();
